enum CertificateSubtypes {
  SAHKOINEN = 'SAHKOINEN',
  EU_VIRANOMAISELLE = 'EU_VIRANOMAISELLE', // Todellisuudessa 'PAPERIPOSTI'
  APOSTILLE = 'APOSTILLE',
  ELOMAKE = 'ELOMAKE',
  KOTIMAINEN = 'KOTIMAINEN',
  // This is not used for anything, just to satisfy NOT NULL constraint for UAET orders.
  // CertificateSubtypes concept will propably be refactored in the future to make its use more clear and explicit.
  UAET = 'UAET',
}

export default CertificateSubtypes
